<template>
  <div class="contenido">
    <h2>{{ father }} | Curricula</h2>
    <v-dialog v-model="nuevoCursoDialog" width="30%">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title"
          >Nuevo Agrupamiento</v-card-title
        >
        <v-row align="center" justify="center" no-gutters>
          <v-col class="pt-4 pr-4 pb-0 pl-4">
            <v-text-field
              v-model="nuevoCurso"
              label="Solo"
              placeholder="Nombre Agrupamiento"
              solo
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters>
          <v-col class="pt-0 pr-4 pb-0 pl-4">
            <v-text-field
              v-model="ordenCurso"
              label="Solo"
              placeholder="Nivel Agrupamiento"
              solo
              @keypress="soloDni"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="pb-4"
          align="center"
          justify="center"
          v-if="msj_error"
          no-gutters
        >
          <v-col class="text-center">
            <label class="msj">{{ texto_msj }}</label>
          </v-col>
        </v-row>
        <v-row class="pb-4" align-center justify="center" no-gutters>
          <v-col class="btn_dialog text-center">
            <v-btn color="primary" @click="guardarAgrupamiento"
              >Guardar Agrupamiento</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <template v-if="cursos.length == 0">
      <v-row align-center>
        <v-col cols="12" class="center">
          <template v-if="loadingCursos">
            <v-progress-circular
              :size="50"
              indeterminate
              color="purple"
            ></v-progress-circular>
          </template>
          <template v-else>
            <h2>No hay cursos cargados actualmente.</h2>
          </template>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row align-center justify="center" no-gutters>
        <v-col md="auto">
          <v-select
            v-model="cursoSeleccionado"
            ref="cursoList"
            :items="cursos"
            item-text="descripcion"
            item-value="id"
            label="Cursos"
            @change="obtenerInformacionCurso($event)"
          ></v-select>
        </v-col>
        <v-col md="auto" align-self="center" class="pl-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                class="agregar_materia_icono"
                v-on="on"
                color="success"
                @click="nuevoCursoDialog = true"
                >mdi-plus-circle</v-icon
              >
            </template>
            <span>Agregar Curso</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <template v-if="cursoSeleccionado.length > 0 && consultas">
        <curricula_detalle
          :resultadoCurricula="resultadoCurricula"
          :materiasDisponibles="materiasDisponibles"
          :idAgrupamiento="cursoSeleccionado"
          :cursos="cursos"
          @curricula_detalle:recargarDatos="obtenerInformacionCurso"
        />
      </template>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import curricula_detalle from "./curricula_detalle/curricula_detalle";
export default {
  data() {
    return {
      cursos: [],
      nuevoCursoDialog: false,
      nuevoCurso: "",
      ordenCurso: "",
      msj_error: false,
      texto_msj: "",
      materiasDisponibles: [],
      resultadoCurricula: [],
      cursoSeleccionado: "",
      consultaCurricula: false,
      consultaMartiasDisponibles: false,
      consultas: false,
      loadingCursos: true
    };
  },
  props: ["father"],
  components: {
    curricula_detalle
  },
  mounted: function() {
    this.obtenerCursos();
  },
  methods: {
    soloDni(e) {
      API.soloNumeros(e);
    },
    mostrarOcultarPreload: function() {
      this.$emit("curricula:mostrarOcultarPreload");
    },
    obtenerCursos() {
      let resultado = API.enviar("get", "obtenerCursos", "");

      resultado
        .then(result => {
          this.$emit("curricula:mostrarOcultarPreload");
          if (result.data.msj == "ok") {
            this.cursos = result.data.result;
            this.$emit("curricula:mostrarOcultarPreload");
          } else this.$emit("curricula:mostrarOcultarPreload");
          this.loadingCursos = false;
        })
        .catch(() => {
          this.$emit("curricula:mostrarOcultarPreload");
        });
    },
    obtenerInformacionCurso: function(event) {
      this.cursoSeleccionado = event;
      this.materiasDisponibles = [];
      this.resultadoCurricula = [];

      this.obtenerCurricula();
      this.obtenerMateriasDisponiblesParaCurricula();
    },
    obtenerCurricula: function() {
      this.materias = [];
      this.$emit("curricula:mostrarOcultarPreload");

      let params = "idAgrupamiento=" + this.cursoSeleccionado;
      let resultado = API.enviar("get", "obtenerCurricula", params);

      resultado
        .then(result => {
          if (result.data.msj == "ok" || result.data.msj == "error") {
            this.resultadoCurricula = result.data;
            this.consultaCurricula = true;
          }

          this.$emit("curricula:mostrarOcultarPreload");
        })
        .catch(() => {});
    },
    obtenerMateriasDisponiblesParaCurricula: function() {
      let params = "idAgrupamiento=" + this.cursoSeleccionado;
      let resultado = API.enviar("get", "obtenerMateriasCurricula", params);

      resultado
        .then(result => {
          if (result.data.msj == "ok") {
            this.materiasDisponibles = result.data.result;
            this.consultaMartiasDisponibles = true;
          }
        })
        .catch(() => {});
    },
    /*agregarCurso: function() {
      //this.loadingCursos = true;
      //this.cursos = [];
      this.nuevoCursoDialog = true;
      console.log("agregarCurso");
      //this.obtenerCursos();
    },*/
    guardarAgrupamiento: function() {
      if (this.nuevoCurso != "") {
        let params = "nombre_curso=" + this.nuevoCurso;
        params += "&nivel_curso=" + this.ordenCurso;
        let resultado = API.enviar("get", "guardarAgrupamiento", params);

        resultado
          .then(result => {
            if (result.data.msj == "ok") {
              this.nuevoCursoDialog = false;
              this.obtenerCursos();
            }
          })
          .catch(() => {
            this.nuevoCursoDialog = false;
          });
      } else {
        this.msj_error = true;
        this.texto_msj = "Debe ingresar un nombre al agrupamiento!";
        console.log("guardarAgrupamiento");
      }
    }
  },
  watch: {
    consultaCurricula: function() {
      this.consultaCurricula && this.consultaMartiasDisponibles;
      this.consultas = true;
    },
    consultaMartiasDisponibles: function() {
      this.consultaCurricula && this.consultaMartiasDisponibles;
      this.consultas = true;
    }
  }
};
</script>

<style>
.contenido {
  width: 100% !important;
}

.titulo {
  padding: 10px;
  border-bottom: solid 1px #ccc;
}

h3 {
  padding: 10px 0 10px 0;
  border-bottom: solid 1px #ccc;
  /*border-top: solid 1px #ccc;*/
}

.materias {
  padding: 10px 20px 0px 20px;
  font-size: 18px;
}

.order {
  width: 80%;
  text-align: center;
  border: dotted 1px #ccc;
}

.center {
  text-align: center;
}

.msj {
  color: red;
  font-weight: bold;
}
</style>